/// Components
/// Types
import Comments from 'components/Comments';
import type { TFieldRelation } from '@timeedit/types/lib/types';
import FieldRelationConfiguration from './sections/FieldRelationConfiguration';
import FieldRelationInfo from './sections/FieldRelationInfo';
import FieldRelationReservationTemplate from './sections/FieldRelationReservationTemplate';
/// Styles
import './FieldRelation.scss';

interface FieldRelationProps {
  fieldRelation?: TFieldRelation;
  onChange: (key: string, value: any) => void;
}

const FieldRelation = ({ fieldRelation, onChange }: FieldRelationProps) => {
  if (!fieldRelation) return null;
  return (
    <div className="field-relations">
      <FieldRelationInfo fieldRelation={fieldRelation} onChange={onChange} />
      <FieldRelationConfiguration
        fieldRelation={fieldRelation}
        onChange={onChange}
      />
      <FieldRelationReservationTemplate
        fieldRelation={fieldRelation}
        onChange={onChange}
      />
      <Comments
        value={fieldRelation.documentation}
        onChange={(val) => onChange('documentation', val)}
      />
    </div>
  );
};

export default FieldRelation;
